import { createAction } from '@reduxjs/toolkit';
import { api, handleApiErrors } from 'lib/src/utils/api';
import { AppDispatch } from 'src/redux/store';
import { Submission } from 'src/types/shared/Assessments';

export const fetchSubmissionRequest = createAction('fetchSubmissionRequest');
export const fetchSubmissionSuccess = createAction<Submission>('fetchSubmissionSuccess');
export const fetchSubmissionFailure = createAction('fetchSubmissionFailure');

export const fetchSubmission = (id: number) => async (dispatch: AppDispatch): Promise<void> => {
    dispatch(fetchSubmissionRequest());
    try {
        const { data } = await api.get<Submission>('admin/challengeapplications/' + id);

        dispatch(fetchSubmissionSuccess(data));
    } catch (e) {
        handleApiErrors(dispatch, fetchSubmissionFailure, e as any);
    }
};
